import Model, { attr } from '@ember-data/model';

export default class DeepDiveGreenOptionOrderModel extends Model {
  @attr
  declare year: number;

  @attr
  declare month: number;

  @attr
  declare numOrders: number;

  @attr
  declare cleaningsSkipped: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'deep-dive/green-option/order': DeepDiveGreenOptionOrderModel;
  }
}
